import React from 'react';
import {TituloGral} from '../tituloGral'

export const TituloCpsi = () => {
    return (
      <>
        <TituloGral/>
      </>
    );
  }